import script from "./AddressSelectionTile.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressSelectionTile.vue?vue&type=script&setup=true&lang=js"

import "./AddressSelectionTile.vue?vue&type=style&index=0&id=84636a74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84636a74"]])

export default __exports__